import { put, select, takeLatest } from "redux-saga/effects";
import { ExternalMessages } from "../../../externalMessages";
import { SummaryGroup } from "../../../models/item";
import { getPublicArticleNumber } from "../../../utilities/itemUtilities";
import { CONFIGURATION_CHANGED, SET_SUMMARIES, SET_TOTAL_PRICE } from "../../actions/configurationActions";
import { TRIGGER_CALL_TO_ACTION } from "../../actions/externalActions";
import { SET_IMAGE_AND_MASK_URL } from "../../actions/imageActions";
import ImageAndMask from "../../models/imageAndMask";
import { getConfigurationString, getCurrentSummaries, getImageAndMask, getTotalPriceText } from "../selectors";

export function* callToActionSaga(): any {
    yield takeLatest(TRIGGER_CALL_TO_ACTION, function* (action: any) {
        const summaries: SummaryGroup[] = yield select(getCurrentSummaries);
        const totalPriceText: string = yield select(getTotalPriceText);
        const imageAndMask: ImageAndMask = yield select(getImageAndMask);
        const configurationString: string = yield select(getConfigurationString);

        const configUrl = new URL(window.location.href);

        // Remove summary suffix (with or without trailing slash).
        configUrl.pathname = configUrl.pathname.replace(/summary\/?$/i, "");

        // Make sure the URL is updated with the config_string even when the config is not reflected to the URL.
        configUrl.searchParams.delete("config_string");
        configUrl.searchParams.append("config_string", configurationString);

        try {
            const message = {
                type: action.action,
                summary: summaries
                    .flatMap(g => g.items)
                    .map(x => ({
                        menuName: x.menuText,
                        itemName: x.name,
                        articleNumber: getPublicArticleNumber(x.articleNumber),
                    })),
                totalPrice: totalPriceText,
                configurationImageUrl: imageAndMask?.configurationImagePath,
                configurationUrl: configUrl.toString(),
            };

            window.parent.postMessage(message, "*");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("CTA error", e);
        }
    });
}

export function* triggerExternalConfiguratorUpdateSaga(): any {
    yield takeLatest([CONFIGURATION_CHANGED, SET_SUMMARIES, SET_TOTAL_PRICE, SET_IMAGE_AND_MASK_URL], function* () {
        yield put({
            type: TRIGGER_CALL_TO_ACTION,
            action: ExternalMessages.CONFIGURATOR_UPDATE,
        });
    });
}
